// Global is for worst case errors, when the entire page or hero section errors out.
export const globalError = 'Global Error Boundary';

export const sectionError = 'Section Error Boundary';
